import Backbone from "backbone";
import { Display } from "../model/Display";
import { Config } from "../application/Config";

export const DisplayCollection = Backbone.Collection.extend({
    model: Display,

    url() {
        return Config.baseUrl.configuration + "/devices";
    },

    sync(method, model, options) {
        var beforeSend = options.beforeSend;
        options.beforeSend = (jqXHR, settings) => {
            //settings.url = Config.baseUrl.configuration + settings.url;
            if (Config.baseUrl.configuration != Config.baseUrl.ui) {
                settings.crossDomain = true;
            }

            if (Config.user && Config.user.has('apiKey')) {
                jqXHR.setRequestHeader("X-USER-ID", Config.user.id);
                jqXHR.setRequestHeader("X-API-KEY", Config.user.get('apiKey'));
                jqXHR.setRequestHeader("X-SELLER-ID", Config.seller.id);
            }

            if (beforeSend) return beforeSend.call(this, jqXHR, settings);
        };

        return Backbone.Model.prototype.sync.call(this, method, model, options);
    }
});


// WEBPACK FOOTER //
// ./src/js/collections/DisplayCollection.js